/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { roleRoutes } from '../../../../modules/role/components/roleRoutes'
import { estateRoutes } from '../../../../modules/twh/components/estate/estateRoutes'
import {
  interventionRoutes
} from '../../../../modules/twh/components/intervention/interventionRoutes'
import { invoiceRoutes } from '../../../../modules/twh/components/invoice/invoiceRoutes'
import { leaseRoutes } from '../../../../modules/twh/components/lease/leaseRoutes'
import {
  managementReportRoutes
} from '../../../../modules/twh/components/management-reports/managementReportRoutes'
import { mandateRoutes } from '../../../../modules/twh/components/mandate/mandateRoutes'
import { prospectingRoutes } from '../../../../modules/twh/components/prospecting/prospectingRoutes'
import { settingRoutes } from '../../../../modules/twh/components/setting/settingRoutes'
import { expenseRoutes } from '../../../../modules/twh/components/transaction/expenseRoutes'
import { userRoutes } from '../../../../modules/user/components/userRoutes'
import AdminPage from './AdminPage'
import { contactRoutes } from '../../../../modules/twh/components/contact/contactRoutes'
import AgencyReportPage from '../../../../modules/twh/components/agency-reports/AgencyReportPage'
import AgendaPage from '../../../../modules/twh/components/agenda/AgendaPage'
import DashboardPage from '../../../../modules/twh/components/dashboard/DashboardPage'
import PaymentListPage from '../../../../modules/twh/components/payment/PaymentListPage'
import { RouteObject } from 'react-router'
import { customerRoutes } from '../../../../modules/twh/components/customer/customerRoutes'
import { revenueRoutes } from '../../../../modules/twh/components/transaction/revenueRoutes'

export const adminRoutes: RouteObject[] = [
  {
    index: true,
    element: <AdminPage />
  },
  {
    path: 'agenda',
    element: <AgendaPage />
  },
  {
    path: 'agency-reports/*',
    element: <AgencyReportPage />
  },
  {
    path: 'contacts/*',
    children: contactRoutes
  },
  {
    path: 'customers/*',
    children: customerRoutes
  },
  {
    path: 'dashboard',
    element: <DashboardPage />
  },
  {
    path: 'estates/*',
    children: estateRoutes
  },
  {
    path: 'interventions/*',
    children: interventionRoutes
  },
  {
    path: 'invoices/*',
    children: invoiceRoutes
  },
  {
    path: 'leases/*',
    children: leaseRoutes
  },
  {
    path: 'management-reports/*',
    children: managementReportRoutes
  },
  {
    path: 'mandates/*',
    children: mandateRoutes
  },
  {
    path: 'payments',
    element: <PaymentListPage />
  },
  {
    path: 'prospecting/*',
    children: prospectingRoutes
  },
  {
    path: 'expenses/*',
    children: expenseRoutes
  },
  {
    path: 'revenues/*',
    children: revenueRoutes
  },
  {
    path: 'roles/*',
    children: roleRoutes
  },
  {
    path: 'settings/*',
    children: settingRoutes
  },
  {
    path: 'users/*',
    children: userRoutes
  }
]
